import React from 'react';
import s from '../../styles/corporate/Corporate.module.css';
import { TECH_STEPS } from './data';
import { useActiveStep } from './hooks';

/** 기술혁신 — 왼쪽은 고정, 오른쪽 단계가 스크롤에 따라 또렷해진다 */
const CorpTech = () => {
  const [active, setStepRef] = useActiveStep(TECH_STEPS.length);

  return (
    <section className={s.tech} id="tech">
      <div className={`${s.wrap} ${s.techGrid}`}>
        <div className={s.techSticky}>
          <h2 className={s.techTitle}>
            데이터가 만드는
            <br />더 나은 비즈니스의 내일.
          </h2>
          <p className={s.techLead}>
            기업 활동에서 얻은 실무 경험을 토대로 업무 데이터의 체계화, 자동화, 분석 및 AI 활용
            기술을 연구하고 있습니다.
          </p>

          <div className={s.techMeter}>
            <span className={s.techMeterNum} translate="no">{`0${active + 1}`}</span>
            <div className={s.techMeterBar}>
              <div
                className={s.techMeterFill}
                style={{ width: `${((active + 1) / TECH_STEPS.length) * 100}%` }}
              />
            </div>
            <span className={s.techMeterTotal} translate="no">{`/ 0${TECH_STEPS.length}`}</span>
          </div>
        </div>

        <div className={s.techSteps}>
          {TECH_STEPS.map((step, i) => (
            <div
              key={step.title}
              ref={setStepRef(i)}
              className={`${s.techStep} ${i === active ? s.techStepOn : ''}`}
            >
              <div className={s.techStepTag} translate="no">{`STEP 0${i + 1}`}</div>
              <div className={s.techStepTitle} translate="no">
                {step.title}
              </div>
              <div className={s.techStepSub}>{step.sub}</div>
              <div className={s.techStepBody}>{step.body}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CorpTech;
